import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=6fe7c3e7&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=6fe7c3e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7c3e7",
  null
  
)

export default component.exports